import React from 'react';
import { IdentityBrokerError, IdentityBrokerErrorType } from '../../components/error-pages/identity-broker-error';
import { getUrlSearchParams } from '../../utils';

export const IdentityBrokerErrorPage: React.FC = () => {
    const errorType = getUrlSearchParams().get('errorType');
    return <IdentityBrokerError type={(errorType as IdentityBrokerErrorType) || 'GENERAL_ERR'} />;
};
